import { AxiosResponse } from 'axios';
import { CoordinateSystem } from 'geojson-transformer';
import v3 from '../v3';

export interface IUser {
  _id: string;
  auth: {
    tel: string;
  };
  cert: {
    name: string;
  };
}

export interface IPointToMeasure {
  _id: string;
  state: number;
  creator: IUser;
  location: {
    geometry: GeoJSON.Point;
    gcj02Geometry: GeoJSON.Point;
  };
  surveyor: IUser;
  measuredAt: Date;
}

export async function findNear(center: ILngLat, radius: number, coordinateSystem: CoordinateSystem): Promise<AxiosResponse<IPointToMeasure[]>> {
  return await v3({
    url: 'operation.pointToMeasure/getPointsByCenter',
    params: {
      center,
      radius,
      coordinateSystem,
    },
  });
}

export async function create(coordinates: ILngLat): Promise<AxiosResponse<IPointToMeasure>> {
  return await v3({
    method: 'post',
    url: 'operation.pointToMeasure',
    data: {
      coordinates,
    },
  });
}

export async function updateLocation(id: string, coordinates: ILngLat, coordinateSystem: CoordinateSystem): Promise<void> {
  await v3({
    method: 'put',
    url: `operation.pointToMeasure/id/${id}/locate`,
    data: {
      coordinates,
      coordinateSystem,
    },
  });
}

export async function remove(id: string): Promise<void> {
  await v3({
    method: 'delete',
    url: `operation.pointToMeasure/id/${id}`,
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/operation/pointToMeasure.ts